import type { FeatureStates } from '../featureStates';
import { hsePlanTemplateId, issueGuidelineTemplateId, riskLevelTemplateId } from '../templates';

import type { EntityType } from '../entityType';

export function isEntityActive(
  entityType: EntityType,
  entity: any,
  features: FeatureStates,
  _parentFuction: any = undefined,
): boolean {
  switch (entityType) {
    case 'assets':
      return features.assets;
    case 'collections':
      return features.collections || (features.healthcare && entity.mainTemplateId === hsePlanTemplateId);
    case 'constitutionalDocuments':
      return features.core;
    case 'contacts':
      return features.core || features.hse;
    case 'contracts':
      return features.core || features.hse;
    case 'competence':
      return features.hseProduct;
    case 'documents':
      return features.core || features.hse;
    case 'employees':
      return features.entityEmployees;
    case 'eventOccurrences':
      return features.entityEvents;
    case 'functions':
      return features.core || features.hse;
    case 'guidelines':
      return (
        features.core ||
        features.hse ||
        (features.risk && entity.mainTemplateId === riskLevelTemplateId) ||
        (features.issues && entity.mainTemplateId === issueGuidelineTemplateId)
      );
    case 'issues':
      return features.issues;
    case 'meetingOccurrences':
      return features.meetings || features.performanceReview;
    case 'meetings':
      return features.meetings;
    case 'partners':
      return features.entityPartners;
    case 'reports':
      return features.core || features.meetings || features.performanceReview;
    case 'riskAssessments':
      return features.risk;
    case 'substances':
      return features.substances;
    case 'tasks':
      return features.core || features.hse;
    case 'tutorials':
      return features.core;
  }
  return false;
}
